<style lang="scss" scoped>
  $leftWidth: 180px;
  .content-part {
    .content-left {
      width: $leftWidth;
    }

    .content-right {
      > h3 {
        left: $leftWidth;
      }

      left: $leftWidth;
    }
  }
</style>

<template>
  <div>
    <div class="content-part">
      <div class="content-left flex">
        <h2 class="clearfix right-title">{{leftTitle}}</h2>
        <ul class="show-list">
          <li class="list-style" v-for="item in pageSets" @click="showPart(item)" :key="item.key"
              v-bind:class="{ 'active' : index===item.key}"><span>{{ item.name }}</span>
          </li>
        </ul>
        <div class="btn-group">
          <el-button type="success" @click="onSubmit" :disabled="doing">保存订单</el-button>
        </div>
      </div>
      <div class="content-right content-padding order-form">
        <h3>{{ title }}</h3>
        <base-info ref="baseInfo" v-show="index === 0" :order="order" @clearGoodsList="clearGoodsList"/>
        <oms-form-row label="" :span="4" v-show="index === 0" style="margin-top: 10px">
          <el-button type="primary" @click="index = 1">添加货品</el-button>
        </oms-form-row>
        <goods-info ref="goodInfo" v-show="index === 1" :order="order" :baseForm="baseForm"/>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseInfo from './base.vue';
  import GoodsInfo from './goods/goods.vue';
  import {BSPOrder} from '@/resources';
  import orderMixin from '@/mixins/orderMixin';

  export default {
    props: {
      orderId: {
        type: String
      },
      defaultIndex: {
        type: Number
      }
    },
    mixins: [orderMixin],
    components: {BaseInfo, GoodsInfo},
    data() {
      return {
        order: {},
        baseForm: {},
        index: 0,
        title: '',
        leftTitle: '',
        doing: false
      };
    },
    watch: {
      defaultIndex(val) {
        this.index = 0;
        this.title = this.pageSets[0].name;
        this.resetForm();
        if (val === 2) {
          this.leftTitle = '添加订单';
        } else if (val === 3) {
          this.leftTitle = '编辑订单';
          this.queryDetail();
        }
      },
      index(val) {
        if (val !== 1) return;
        this.baseForm = this.$refs.baseInfo.form;
      }
    },
    computed: {
      pageSets() {
        let menu = [];
        menu.push({name: '基本信息', key: 0});
        menu.push({name: '添加货品', key: 1});
        return menu;
      }
    },
    methods: {
      clearGoodsList() {
        const goodInfo = this.$refs.goodInfo;
        goodInfo.resetForm();
      },
      queryDetail() {
        if (!this.orderId) return;
        BSPOrder.get(this.orderId).then(res => {
          res.data.details.forEach(i => {
            i.amount = i.orderAmount;
            i.unitPrice = i.orderPrice;
            i.code = i.goodsCode;
            i.specifications = i.specification;
          });
          res.data.upstreamOrgDhsId = res.data.upstreamOrgId;
          res.data.downstreamOrgDhsId = res.data.downstreamOrgId;
          res.data.thirdLogisticsDhsId = res.data.thirdLogisticsId;
          res.data.goodsType = res.data.orderGoodsType;
          this.order = res.data;
        });
      },
      showPart(item) {
        this.index = item.key;
        this.title = item.name;
      },
      resetForm() {
        const baseInfo = this.$refs.baseInfo;
        const goodInfo = this.$refs.goodInfo;
        baseInfo.resetForm();
        goodInfo.resetForm();
      },
      onSubmit() {
        const baseInfo = this.$refs.baseInfo;
        const goodInfo = this.$refs.goodInfo;
        baseInfo.$refs.form.validate(valid => {
          if (!valid) {
            this.index = 0;
            return;
          }
          if (this.doing) return;
          if (!goodInfo.goodsList.length) {
            this.index = 1;
            return this.$notify({
              duration: 2000,
              message: '请添加货品',
              type: 'warning'
            });
          }
          const order = Object.assign({}, baseInfo.form);
          order.type = this.type; // 订单类型
          order.detailList = goodInfo.goodsList.map(m => {
            let data = {
              goodsId: m.goodsId,
              goodsName: m.goodsName,
              goodsCode: m.code,
              orderAmount: m.amount,
              orderPrice: m.unitPrice,
              batchNumber: m.batchNumber
            };
            if (m.supplyManufacturersId) {
              data.supplyManufacturersId = m.supplyManufacturersId;
              data.supplyManufacturers = m.supplyManufacturers;
              data.supplyManufacturersCode = m.supplyManufacturersCode;
            }
            return data;
          });
          if (order.id) {
            this.doing = true;
            BSPOrder.update(order.id, {order}).then(res => {
              this.$notify.success('编辑成功');
              this.doing = false;
              this.$emit('refresh');
              this.resetForm();
            }).catch(e => {
              this.doing = false;
              this.$notifyError(e, '编辑失败');
            });
          } else {
            this.doing = true;
            BSPOrder.addLogisticsOrder({order}).then(res => {
              this.$notify.success('新增成功');
              this.doing = false;
              this.$emit('refresh');
              this.resetForm();
            }).catch(e => {
              this.doing = false;
              this.$notifyError(e, '新增失败');
            });
          }
        });
      }
    }
  };
</script>
